import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function News() {
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data.news || [])); }, []);
  return (
    <div className="max-w-4xl mx-auto px-6 md:px-12 py-14">
      <div className="text-xs uppercase tracking-widest text-labor-muted">Ultime notizie</div>
      <h1 className="font-display text-5xl mt-2 mb-8">Newsletter CAF Labor</h1>
      {news.length === 0 && <div className="text-labor-muted">Nessuna comunicazione al momento.</div>}
      <div className="space-y-5">
        {news.map((n) => (
          <article key={n.id} data-testid={`news-item-${n.id}`} className="paper-card p-7">
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-labor-muted mb-2">
              {n.pinned && <span className="bg-labor-terracotta text-white px-2 py-0.5">IMPORTANTE</span>}
              <span>{new Date(n.created_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</span>
            </div>
            <h2 className="font-display text-3xl mb-3">{n.title}</h2>
            <p className="text-labor-ink text-[17px] leading-relaxed whitespace-pre-line">{n.body}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
